
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Rentabusforatrip() {



    const cardData =
    {
        keyword: 'Rent a Bus For a Trip ',
        heading: 'Amruta Travels: Rent a Bus For a Trip ',
        headingDescription: 'Amruta Travels offers Rent a Bus for a Trip, providing flexible and convenient transportation solutions for all types of group travel. Whether you are planning a weekend getaway, school excursion, corporate outing, religious tour, or family vacation, our well-maintained buses ensure a safe and comfortable journey. Choose from a wide range of seating options including 17-seater, 25-seater, 32-seater, and 50-seater buses to match your group size. With professional drivers, on-time service, competitive rates, and 24/7 support, Amruta Travels makes your trip enjoyable, stress-free, and memorable. Book your bus today and travel with comfort and confidence!',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


 "services": [
    {
      "name": "Rent a Bus for a Trip Pune",
      "description": "Amruta Travels provides reliable bus rental services in Pune for one-day or multi-day trips. Choose from a fleet of minibuses, AC coaches, or sleeper buses based on your group size and travel needs. Ideal for family outings, group tours, and leisure trips."
    },
    {
      "name": "Rent a Bus for a Trip Near Me Pune",
      "description": "Looking to rent a bus for a trip near your location in Pune? Amruta Travels offers convenient and quick bus booking services throughout Pune, including areas like Kothrud, Kharadi, Hadapsar, and Hinjewadi. Our team ensures timely pickup and a smooth travel experience."
    },
    {
      "name": "Rent School Bus for a Party Near Me",
      "description": "Turn your celebration into a mobile event with school bus rentals for parties. Whether it’s a birthday, picnic, or kids’ outing, Amruta Travels offers safe and budget-friendly school buses equipped with all the basics for group fun and safe travel."
    },
    {
      "name": "Rent a Bus for a Day Trip",
      "description": "Planning a one-day trip from Pune? Amruta Travels offers buses on rent for day tours to destinations like Lonavala, Mahabaleshwar, Alibaug, and more. Enjoy comfortable seating, experienced drivers, and hassle-free transportation for the entire group."
    },
    {
      "name": "Sleeper Bus on Rent in Pune",
      "description": "Hire a sleeper bus in Pune for comfortable long-distance travel. Our sleeper buses are ideal for overnight journeys, equipped with sleeper berths, air-conditioning, curtains, and ample luggage space for group trips, pilgrimages, or office events."
    },
    {
      "name": "Renting a Bus for a Field Trip",
      "description": "Organize educational field trips from Pune with Amruta Travels' school bus rental services. We offer safe, spacious, and well-maintained buses along with trained drivers to ensure the safety of students and staff on academic excursions."
    },
    {
      "name": "Rent Bus for Weekend Trip",
      "description": "Escape the city with our weekend bus rental options. Amruta Travels provides flexible weekend bus hire services for destinations like Matheran, Panchgani, Lavasa, and more. Choose from 17, 25, 32, or 50 seater buses depending on your group size."
    },
    {
      "name": "Rent a Bus for Corporate Events in Pune",
      "description": "Amruta Travels offers premium bus rental services for corporate events in Pune. From team outings to off-site conferences, we provide AC buses, luxury coaches, and punctual service to ensure your event transport runs smoothly."
    },
    {
      "name": "Luxury Bus on Rent in Pune",
      "description": "Travel in style with our luxury bus rentals in Pune. Perfect for weddings, corporate functions, or VIP travel, our fleet includes high-end AC coaches with pushback seats, entertainment systems, and professional chauffeurs for a superior experience."
    },
    {
      "name": "Bharat Benz Bus on Rent",
      "description": "Book Bharat Benz buses in Pune for high-performance, reliable, and comfortable transport. These buses are suitable for long-distance journeys, corporate use, or tourism, and come with modern amenities and a smooth ride experience."
    },
    {
      "name": "Bharat Benz Sleeper Bus on Rent",
      "description": "Enjoy the comfort of Bharat Benz sleeper buses for overnight travel from Pune. These luxury sleeper coaches offer sleeping berths, spacious interiors, and air-conditioning, ideal for pilgrimages, wedding travel, and multi-city tours."
    },
    {
      "name": "Luxury Bharat Benz Coach Bus on Rent in Pune",
      "description": "Travel in class with our luxury Bharat Benz coach buses. Ideal for premium events, weddings, and VIP transport in and around Pune, these buses feature elegant interiors, reclining seats, and experienced staff to provide a first-class experience."
    },
    {
      "name": "Rent School Bus for Event",
      "description": "Rent a school bus for your upcoming event with Amruta Travels. Whether it's for guest transportation, kids’ events, or educational programs, we offer clean, safe, and punctual school bus services with flexible rental durations."
    },
    {
      "name": "Amruta Travels Karve Nagar",
      "description": "Located in Karve Nagar, Amruta Travels is your local bus rental expert for tours, corporate trips, pilgrimages, and school events. Visit or contact us to explore our range of vehicles including Urbania, sleeper buses, and AC coaches."
    }
  ],
  "tableData": [
    ["Rent a Bus for a Trip Pune", "Rent a Bus for a Trip Near Me Pune"],
    ["Rent School Bus for a Party Near Me", "Rent a Bus for a Day Trip"],
    ["Sleeper Bus on Rent in Pune", "Renting a Bus for a Field Trip"],
    ["Rent Bus for Weekend Trip", "Rent a Bus for Corporate Events in Pune"],
    ["Luxury Bus on Rent in Pune", "Bharat Benz Bus on Rent"],
    ["Bharat Benz Sleeper Bus on Rent", "Luxury Bharat Benz Coach Bus on Rent in Pune"],
    ["Rent School Bus for Event", "Amruta Travels Karve Nagar"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Easy and Convenient Bus Rentals for Your Trip",
    "WhyChoosedescription": "Amruta Travels offers a hassle-free and convenient bus rental service for all your trip needs. Whether you’re planning a corporate outing, a school field trip, or a family vacation, we provide well-maintained, comfortable buses for every type of journey. Renting a bus for your trip ensures that your group travels together in comfort and style, with a professional driver ensuring smooth and safe travel."
  },
  {
    "WhyChooseheading": "Variety of Bus Sizes to Match Your Group's Needs",
    "WhyChoosedescription": "From small groups of 10-20 passengers to larger groups of 50, we have a variety of buses to suit your needs. Our fleet includes compact buses, 17-seater vans, 25-seater buses, and larger 32, 35, and 50-seater coaches, giving you flexible options for your trip. Whether it’s a small family getaway or a large corporate or school trip, we have the right vehicle for you."
  },
  {
    "WhyChooseheading": "Comfort and Convenience for Every Journey",
    "WhyChoosedescription": "Our buses are designed to offer maximum comfort during your trip. With plush, reclining seats, ample legroom, air conditioning, and clean facilities, your group will have a pleasant experience from start to finish. We also provide onboard amenities like USB charging ports, sound systems, and Wi-Fi (depending on the vehicle), ensuring your journey is both relaxing and enjoyable."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Your trip will be in safe hands with our experienced and courteous drivers. They are well-trained, punctual, and familiar with the routes to ensure your trip runs on schedule. Whether you're going on a local trip within Pune or an outstation journey, our drivers are committed to providing a safe and smooth ride."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Transparent Billing",
    "WhyChoosedescription": "We offer competitive and transparent pricing for bus rentals. The quoted price covers all major expenses including fuel, tolls, driver charges, and taxes. There are no hidden fees or surprise charges, allowing you to plan your budget effectively. Whether you're renting for a few hours or an entire day, we provide value for money without compromising on comfort or safety."
  },
  {
    "WhyChooseheading": "Flexible Itineraries and Customized Trips",
    "WhyChoosedescription": "At Amruta Travels, we understand that every trip is unique. We offer customizable itineraries to fit your schedule and preferences. Whether you need to make multiple stops, have a specific pick-up time, or require a tailored route, our team is happy to assist. We work closely with you to design a trip that fits your exact needs and ensures a seamless travel experience."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for a Smooth Journey",
    "WhyChoosedescription": "Our buses are regularly serviced and cleaned to ensure a smooth and comfortable ride. From the interiors to the engine, we maintain the highest standards of upkeep, ensuring that your vehicle is in excellent condition. You can rest assured that the bus will be clean, functional, and ready for your trip."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Renting a bus with Amruta Travels is quick and easy. Our online booking system, along with our customer support team available 24/7, makes it easy to book your trip at any time. Whether it’s a last-minute booking or planning in advance, we’re here to assist you at every step, from booking to final drop-off."
  }
]
















    }

const faqData = [
  {
    question: 'How can I rent a bus for a trip?',
    answer: 'Renting a bus for your trip with Amruta Travels is easy. You can book through our website, contact our support team, or visit our office to discuss your requirements and get a tailored quote for your trip.',
  },
  {
    question: 'What types of buses can I rent for a trip?',
    answer: 'We offer a variety of buses depending on your group size and requirements, including 12, 25, 32, 35, 40, 45, and 50-seater buses. We also offer luxury buses for those seeking a more comfortable ride.',
  },
  {
    question: 'Are the buses available for both local and outstation trips?',
    answer: 'Yes, our buses are available for both local trips within Pune and outstation travel. Whether you are planning a city tour, a wedding guest transport, or a long-distance trip, we have buses suited for every occasion.',
  },
  {
    question: 'Do you offer AC and non-AC buses for trips?',
    answer: 'Yes, we provide both AC and non-AC buses depending on your preferences and budget. Our AC buses are perfect for long trips, while non-AC buses are ideal for shorter or budget-friendly trips.',
  },
  {
    question: 'Do you provide drivers with the bus rental?',
    answer: 'Yes, all our bus rentals come with experienced and licensed drivers who ensure a safe, comfortable, and punctual journey. They are familiar with local routes and outstation routes to ensure smooth travel.',
  },
  {
    question: 'Can I customize the bus rental for my trip?',
    answer: 'Yes, we offer customizable options for your trip. You can choose pick-up and drop-off locations, set your itinerary, and even add services like meals, sightseeing, or extra stops along the way.',
  },
  {
    question: 'How much does it cost to rent a bus for a trip?',
    answer: 'The cost depends on the type of bus, trip duration, distance, and other factors. Contact us with your trip details for a personalized and transparent quote.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Yes, all our buses are regularly serviced and thoroughly sanitized before each trip to ensure the safety and comfort of all passengers.',
  },
  {
    question: 'Why choose Amruta Travels for bus rentals?',
    answer: 'Amruta Travels is known for providing reliable, punctual, and comfortable bus rentals. We offer well-maintained vehicles, experienced drivers, and excellent customer service to ensure a hassle-free trip for you and your group.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Pravin Deshmukh',
    role: 'Corporate Event Coordinator',
    text: 'We rented a bus from Amruta Travels for a company trip. The booking process was easy, the bus was comfortable, and the driver was excellent. Our team had a great experience!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Shilpa Reddy',
    role: 'Wedding Planner',
    text: 'We hired a bus for transporting wedding guests. The bus was clean, spacious, and the driver was very professional. Everyone was comfortable and happy. Thank you, Amruta Travels!',
    rating: 5,
  },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Rent a Bus For a Trip",
  "image": "https://bushireinpune.com/assets/images/rent-a-bus-for-a-trip.jpg",
  "description": "Rent a bus for your trip from Pune with Amruta Travels. Offering buses for day trips, weekend getaways, school field trips, corporate events, and luxury travel. Choose from sleeper buses, luxury Bharat Benz coaches, and more. Reliable and affordable bus rental services in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "14125"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/rent-a-bus-for-a-trip"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Rent a Bus for a Trip in Pune | Day Trips, Weekend Getaways, School & Corporate Events | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a bus for your trip in Pune with Amruta Travels. Choose from sleeper buses, luxury Bharat Benz coaches, and more. Available for day trips, weekend getaways, school field trips, and corporate events." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Rentabusforatrip;